import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { get, post } from "../../../helpers/api_helper";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";

import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";

import moment from "moment";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import {
  POST_GetCustomerDDLListAJAX,
  POST_GetCustomerProjectList,
  POST_GetDepartmentDropDownList,
  POST_GetProcessStatusReportExport,
  POST_GetReportProcessStatusList,
  POST_GetRequestTypeDDLList,
} from "../../../helpers/url_helper";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import { errorMessage } from "../CommonFunctions";

const ProcessStatus = () => {
  const [showFilter, setShowFilter] = useState(true);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("asc");

  const [isReset, setIsReset] = useState(false);

  const [processStatusList, setProcessStatusList] = useState([]);
  const [customerProjectOptions, setCustomerProjectOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [requestTypeOptions, setRequestTypeOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      InwardNo: "",
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      TCNo: "",
      DepartmentIDEncrypted: "",
      WorkDetail: "",
      LetterRefNo: "",
      Search: "",
      Status: -1,
      RequestType: "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      Search,
      Status,
      InwardNo,
      FromDate,
      ToDate,
      CustomerIDEncrypted,
      CustomerName,
      CustomerProjectIDEncrypted,
      DepartmentIDEncrypted,
      TCNo,
      WorkDetail,
      LetterRefNo,
      RequestType,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    getDepartmentDDL();
    getRequestTypeDDL();
  }, []);

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypted: CustomerIDEncrypted,
      ProjectIDEncrypted: CustomerProjectIDEncrypted,
      DepartmentIDEncrypted: DepartmentIDEncrypted,
      TCNo: TCNo,
      InwardNo: InwardNo,
      ProjectDetails: WorkDetail,
      LetterRefNo: LetterRefNo,
      RequestType: RequestType ? RequestType : 0,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    };

    await post(POST_GetReportProcessStatusList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setProcessStatusList(response?.List);

        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getRequestTypeDDL = async () => {
    //setIsLoading(true);
    await post(POST_GetRequestTypeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setRequestTypeOptions(
            response?.List?.map((item) => ({
              label: item?.RequestTypeName,
              value: item?.RequestType,
            })),
          );
        }
        //setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const loadOptionsCutomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerProjectDDL = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: customerID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            })),
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted,
            ).length == 0
          ) {
            formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const getDepartmentDDL = async () => {
    setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item.DepartmentName,
              value: item.DepartmentIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (CustomerIDEncrypted) {
      getCustomerProjectDDL(CustomerIDEncrypted);
    } else {
      setCustomerProjectOptions([]);
      formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
    }
  }, [CustomerIDEncrypted]);

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypted: CustomerIDEncrypted,
      ProjectIDEncrypted: CustomerProjectIDEncrypted,
      DepartmentIDEncrypted: DepartmentIDEncrypted,
      TCNo: TCNo,
      InwardNo: InwardNo,
      ProjectDetails: WorkDetail,
      LetterRefNo: LetterRefNo,
      RequestType: RequestType ? RequestType : 0,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };
    post(POST_GetProcessStatusReportExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getResetData = async () => {
    setIsLoading(true);

    formikFilter.setValues({
      InwardNo: "",
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      TCNo: "",
      Process: "",
      ProcessStatus: "",
      DepartmentIDEncrypted: "",
      WorkDetail: "",
      LetterRefNo: "",
      Search: "",
      Status: -1,
      RequestType: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="active-projects style-1">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Process Status</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  title="Go to Reports"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa-solid fa-table" /> Back to Report Menu
                </button>

                <button
                  type="button"
                  title="Reset"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>{" "}
                  Reset
                </button>
                <button
                  type="button"
                  title="Filter"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                <Link
                  title="Export Report"
                  className="btn btn-outline-primary btn-sm"
                  onClick={exportReport}
                >
                  <i className="fa-solid fa-file-excel" /> Export Report
                </Link>
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              {showFilter ? (
                <div>
                  <FormikProvider value={formikFilter}>
                    <Form onSubmit={formikFilter.handleSubmit}>
                      <Row className="me-0">
                        <Col lg={2}>
                          <Field
                            label="TC No"
                            name="TCNo"
                            placeholder={"Search here..."}
                            component={CustomInput}
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Inward No"
                            name="InwardNo"
                            placeholder={"Search Inward No"}
                            component={CustomInput}
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Request Type"
                            name="RequestType"
                            placeholder={"Select Request Type"}
                            options={requestTypeOptions}
                            component={CustomSelect}
                            menuStyles={{
                              position: "absolute",
                              right: 0,
                            }}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Customer"
                            name="CustomerIDEncrypted"
                            placeholder={"Select Customer"}
                            loadOptionsFn={loadOptionsCutomer}
                            component={CustomSelectAsync}
                            title={CustomerName}
                            labelFieldName="CustomerName"
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Project"
                            name="CustomerProjectIDEncrypted"
                            placeholder={"Select Project"}
                            options={customerProjectOptions}
                            component={CustomSelect}
                            menuPosition="fixed"
                            menuStyles={{
                              position: "absolute",
                              right: 0,
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={2}>
                          <Field
                            label="Department"
                            name="DepartmentIDEncrypted"
                            placeholder={"Select Department"}
                            options={departmentOptions}
                            component={CustomSelect}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Letter Ref No"
                            name="LetterRefNo"
                            placeholder={"Search Letter Ref No"}
                            component={CustomInput}
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Work Detail"
                            name="WorkDetail"
                            placeholder={"Search Work Detail"}
                            component={CustomInput}
                            maxLength={2000}
                          />
                        </Col>
                        <Col lg={3}>
                          <div className="d-flex">
                            <Field
                              label="From Date"
                              name="FromDate"
                              placeholder={"Select From Date"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                              }}
                              autoFocus
                            />

                            <div>&nbsp;</div>
                            <Field
                              label="To Date"
                              name="ToDate"
                              placeholder={"Select To Date"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                                minDate: FromDate,
                              }}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex">
                            <div className="d-lg-block">
                              <Link
                                className="btn btn-primary btn-sm mb-1"
                                onClick={(e) => {
                                  getData();
                                }}
                              >
                                <i
                                  className="fa fa-search"
                                  aria-hidden="true"
                                ></i>
                                {"  "} Search
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              ) : (
                ""
              )}
              <div
                id="ProcessStatus-tbl_wrapper"
                className="dataTables_wrapper  table-responsive shorting"
              >
                <table
                  id="ProcessStatus-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Inward No </th>
                      <th>Inward Date</th>
                      <th>Request Type</th>
                      <th>TC No</th>
                      <th>Customer</th>
                      <th>EDD</th>
                      <th>Sample Name</th>
                      <th>Letter Ref No</th>
                      <th>Test Name</th>
                      <th>Material Inward</th>
                      {AuthUser?.Permissions?.DT == 1 && <th>TC Allocation</th>}
                      {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                      AuthUser?.Permissions?.InwardApprovalRequired == true ? (
                        <th>Inward Approve</th>
                      ) : (
                        ""
                      )}
                      <th>Testing</th>
                      {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                      AuthUser?.Permissions?.TestingApprovalRequired == true ? (
                        <th>Testing Approve</th>
                      ) : (
                        ""
                      )}
                      {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                      AuthUser?.Permissions?.ReportPrintApprovalRequired ==
                        true ? (
                        <th>Report Printing Approval</th>
                      ) : (
                        ""
                      )}
                      <th style={{ textAlign: "left" }}>Report Printing</th>
                      {AuthUser?.Permissions?.DispatchReport == 1 && (
                        <th style={{ textAlign: "left" }}>Dispatch Report</th>
                      )}
                      {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                        <th style={{ textAlign: "left" }}>Dispatch Material</th>
                      ) : (
                        ""
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {processStatusList?.length > 0 ? (
                      processStatusList?.map((item, indx) => (
                        <tr key={indx}>
                          <td
                            className="text-center"
                            style={{ verticalAlign: "top" }}
                          >
                            {item?.RowNo}
                          </td>
                          <td style={{ verticalAlign: "top" }}>
                            {item.InwardNo}
                          </td>
                          <td style={{ verticalAlign: "top" }}>
                            {item.InwardDate}
                          </td>
                          <td style={{ verticalAlign: "top" }}>
                            {item.RequestTypeName}
                          </td>
                          <td style={{ verticalAlign: "top" }}>{item.TCNo}</td>

                          <td
                            style={{
                              cursor: "pointer",
                              textAlign: "left",
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                            className="popupOverlayReports"
                          >
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              key={indx}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {item.CustomerName}
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>{item.CustomerName}</span>
                            </OverlayTrigger>
                          </td>
                          <td style={{ verticalAlign: "top" }}>
                            {item.ExpectedDateOfDelivery}
                          </td>
                          <td
                            style={{
                              cursor: "pointer",
                              textAlign: "left",
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                            className="popupOverlayReports"
                          >
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              key={indx}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {item.SampleDetail}
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>{item.SampleDetail}</span>
                            </OverlayTrigger>
                          </td>

                          <td style={{ verticalAlign: "top" }}>
                            {item.LetterRefNo}
                          </td>
                          <td style={{ verticalAlign: "top" }}>
                            {/* {item.TestNames} */}
                            {item?.TestNames?.split(",").map((tName, idx) => (
                              <>
                                {tName} <br></br>
                              </>
                            ))}
                          </td>

                          <td style={{ verticalAlign: "top" }}>
                            {item.MaterialInward} <br></br>
                            {item?.MaterialInwardDate}
                          </td>

                          {AuthUser?.Permissions?.DT == 1 && (
                            <td style={{ verticalAlign: "top" }}>
                              {item.TCAllocation} <br></br>
                              {item?.TCAllocationDate}
                            </td>
                          )}
                          {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                          AuthUser?.Permissions?.InwardApprovalRequired ==
                            true ? (
                            <td style={{ verticalAlign: "top" }}>
                              {item.InwardApprove} <br></br>
                              {item?.InwardApproveDate}
                            </td>
                          ) : (
                            ""
                          )}

                          <td style={{ verticalAlign: "top" }}>
                            {/* {item?.Testing} */}
                            {item?.Testing?.split(",").map((tName, idx) => (
                              <>
                                {tName} <br></br>
                              </>
                            ))}
                          </td>
                          {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                          AuthUser?.Permissions?.TestingApprovalRequired ==
                            true ? (
                            <td style={{ verticalAlign: "top" }}>
                              {/* {item.TestingApprove} */}
                              {item?.TestingApprove?.split(",").map(
                                (tName, idx) => (
                                  <>
                                    {tName} <br></br>
                                  </>
                                ),
                              )}
                            </td>
                          ) : (
                            ""
                          )}
                          {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                          AuthUser?.Permissions?.ReportPrintApprovalRequired ==
                            true ? (
                            <td style={{ verticalAlign: "top" }}>
                              {/* {item.ReportPrintApprove} */}
                              {item?.ReportPrintApprove?.split(",").map(
                                (tName, idx) => (
                                  <>
                                    {tName} <br></br>
                                  </>
                                ),
                              )}
                            </td>
                          ) : (
                            ""
                          )}
                          <td
                            style={{ verticalAlign: "top", textAlign: "left" }}
                          >
                            {item.ReportPrinting}
                          </td>
                          {AuthUser?.Permissions?.DispatchReport == 1 && (
                            <td
                              style={{
                                verticalAlign: "top",
                                textAlign: "left",
                              }}
                            >
                              {item.DispatchReport}
                            </td>
                          )}
                          {AuthUser?.Permissions?.DispatchMaterial == 1 ? (
                            <td
                              style={{
                                verticalAlign: "top",
                                textAlign: "left",
                              }}
                            >
                              {item.DispatchMaterial}
                            </td>
                          ) : (
                            ""
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={20} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-sm-flex text-center justify-content-between align-items-center reports">
                <CustomSizePerPage
                  getData={getData}
                  currentSizePerPage={currentSizePerPage}
                />
                <div className="dataTables_info">
                  Showing{" "}
                  {recordCount > 0
                    ? (currentPage - 1) * currentSizePerPage + 1
                    : 0}{" "}
                  to{" "}
                  {recordCount > currentPage * currentSizePerPage
                    ? currentPage * currentSizePerPage
                    : recordCount}{" "}
                  of {recordCount} entries
                </div>
                <CustomPaginationButtons
                  totalPages={recordCount / currentSizePerPage}
                  currentPage={currentPage}
                  currentSizePerPage={currentSizePerPage}
                  getData={getData}
                />
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default ProcessStatus;
